<div [class.active]="isActive" [class.selected]="isSelected" 
    class="sidebar-item tw-group tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl tw-cursor-pointer tw-transition-all
        [&.selected]:tw-bg-[var(--sys-hover)] [&.selected]:tw-scale-[0.98]">
    
    <div class="tw-flex tw-text-[var(--sys-secondary-text)] group-[.active]:tw-text-[var(--sys-primary)]">
        <ng-content select="[start]"></ng-content>
    </div>

    <!-- <div class="tw-flex-grow tw-truncate tw-text-sm tw-font-medium">
        <ng-content></ng-content>
    </div> -->

    <div class="tw-flex-grow tw-flex tw-flex-col tw-min-w-0 tw-justify-center">
        <div class="tw-truncate tw-text-sm tw-font-bold tw-text-[var(--sys-text)] tw-leading-tight">
            <ng-content select="[title]"></ng-content>
        </div>
        
        @if(hasSubtitle) {
            <div class="tw-truncate tw-text-[11px] tw-text-[var(--sys-secondary-text)] tw-mt-0.5 tw-leading-tight">
                <ng-content select="[subtitle]"></ng-content>
            </div>
        }
    </div>

    <div class="tw-flex-shrink-0">
        <ng-content select="[end]"></ng-content>
    </div>
</div>